/* 8TH SIN — CART DRAWER v4
   - Skip on /cart page
   - Document-level event delegation (no timing issues with ATC)
   - No race conditions via isBusy flag
   - replaceChild() prevents stale listeners
*/
(function () {
  'use strict';

  if (window.location.pathname === '/cart') return;
  if (document.getElementById('cartDrawer')) return;

  var isOpen = false;
  var isBusy = false;

  document.body.insertAdjacentHTML('beforeend',
    '<div id="cartDrawerOverlay" class="cart-drawer-overlay"></div>' +
    '<div id="cartDrawer" class="cart-drawer" aria-hidden="true">' +
      '<div class="cart-drawer-head">' +
        '<div><span class="cart-drawer-title">Your Cart</span>' +
        '<span class="cart-drawer-count" id="cartDrawerCount"></span></div>' +
        '<button class="cart-drawer-close" id="cartDrawerClose">&#x2715;</button>' +
      '</div>' +
      '<div class="cart-drawer-items" id="cartDrawerItems">' +
        '<div class="cart-drawer-empty"><span>Your cart is empty</span></div>' +
      '</div>' +
      '<div class="cart-drawer-foot" id="cartDrawerFoot" style="display:none">' +
        '<div class="cart-subtotal-row">' +
          '<span class="cart-subtotal-label">Subtotal</span>' +
          '<span class="cart-subtotal-val" id="cartSubtotal"></span>' +
        '</div>' +
        '<span class="cart-subtotal-note">Taxes and shipping calculated at checkout</span>' +
        '<button class="cart-checkout-btn" id="cartCheckoutBtn">Proceed to Checkout</button>' +
      '</div>' +
    '</div>'
  );

  var overlay    = document.getElementById('cartDrawerOverlay');
  var drawer     = document.getElementById('cartDrawer');
  var footEl     = document.getElementById('cartDrawerFoot');
  var countEl    = document.getElementById('cartDrawerCount');
  var subtotalEl = document.getElementById('cartSubtotal');

  function openCart() {
    isOpen = true;
    drawer.classList.add('open');
    overlay.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }

  function closeCart() {
    isOpen = false;
    drawer.classList.remove('open');
    overlay.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.getElementById('cartDrawerClose').addEventListener('click', closeCart);
  overlay.addEventListener('click', function(e) { if (e.target === overlay) closeCart(); });
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape' && isOpen) closeCart(); });
  document.getElementById('cartCheckoutBtn').addEventListener('click', function() {
    window.location.href = '/checkout';
  });

  /* Cart nav links — capture phase delegation, works on all pages */
  document.addEventListener('click', function(e) {
    var el = e.target.closest('.pm-nav-cart, .cg-nav-cart, .pg-nav-cart, .cv-nav-cart');
    if (el) { e.preventDefault(); e.stopPropagation(); openCart(); }
  }, true);

  /* ATC buttons — document delegation means no load-order dependency */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.pm-btn-atc');
    if (!btn || btn.disabled) return;
    var variantId = btn.dataset.variantId;
    if (!variantId) return;
    e.preventDefault();
    doAddToCart(variantId, btn);
  });

  async function doAddToCart(variantId, btn) {
    var orig = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding\u2026';
    try {
      var r1 = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
      });
      if (!r1.ok) throw new Error();
      var r2 = await fetch('/cart.js', { cache: 'no-store' });
      var cart = await r2.json();
      syncCount(cart.item_count);
      btn.textContent = 'Added \u2713';
      btn.classList.add('added');
      setTimeout(function() {
        btn.textContent = orig;
        btn.classList.remove('added');
        btn.disabled = false;
      }, 2200);
      openCart();
    } catch (err) {
      btn.textContent = 'Try Again';
      btn.disabled = false;
      setTimeout(function() { btn.textContent = orig; }, 2000);
    }
  }

  /* Buy Now */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.pm-btn-buy');
    if (!btn || btn.disabled) return;
    var variantId = btn.dataset.variantId;
    if (!variantId) return;
    e.preventDefault();
    doBuyNow(variantId, btn);
  });

  async function doBuyNow(variantId, btn) {
    btn.disabled = true;
    btn.textContent = 'Processing\u2026';
    try {
      await fetch('/cart/clear.js', { method: 'POST' });
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
      });
      window.location.href = '/checkout';
    } catch (err) {
      btn.disabled = false;
      btn.textContent = 'Buy Now';
    }
  }

  async function fetchCart() {
    if (isBusy) return;
    isBusy = true;
    var itemsEl = document.getElementById('cartDrawerItems');
    itemsEl.innerHTML = '<div class="cart-drawer-empty"><span>Loading\u2026</span></div>';
    footEl.style.display = 'none';
    try {
      var cart = await fetch('/cart.js', { cache: 'no-store' }).then(function(r) { return r.json(); });
      syncCount(cart.item_count);
      if (cart.item_count === 0) {
        countEl.textContent = '';
        itemsEl.innerHTML = '<div class="cart-drawer-empty"><span>Your cart is empty</span><a href="/collections/all">Continue Shopping</a></div>';
        isBusy = false;
        return;
      }
      countEl.textContent = '(' + cart.item_count + ')';
      subtotalEl.textContent = money(cart.total_price);
      footEl.style.display = 'flex';

      /* Replace node to wipe old listeners */
      var fresh = itemsEl.cloneNode(false);
      itemsEl.parentNode.replaceChild(fresh, itemsEl);
      fresh.innerHTML = cart.items.map(renderItem).join('');
      fresh.addEventListener('click', itemsClickHandler);
    } catch (err) {
      var el = document.getElementById('cartDrawerItems');
      if (el) el.innerHTML = '<div class="cart-drawer-empty"><span>Error — please refresh</span></div>';
    }
    isBusy = false;
  }

  function renderItem(item) {
    var showV = item.variant_title && item.variant_title !== 'Default Title';
    var img = '';
    if (item.image) {
      // Strip any existing Shopify size suffix, then add 300x400
      img = item.image
        .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|[0-9]+x[0-9]*)(\.)/, '$2')
        .replace(/(\.[^.?]+)(\?.*)?$/, '_300x400$1$2');
    }
    return '<div class="cart-item" data-key="' + x(item.key) + '">' +
      '<div class="cart-item-img">' + (img ? '<img src="' + x(img) + '" alt="' + x(item.product_title) + '" loading="lazy">' : '') + '</div>' +
      '<div class="cart-item-info">' +
        '<div class="cart-item-name">' + x(item.product_title) + '</div>' +
        (showV ? '<div class="cart-item-variant">' + x(item.variant_title) + '</div>' : '') +
        '<div class="cart-item-price">' + money(item.final_line_price) + '</div>' +
        '<div class="cart-item-actions">' +
          '<div class="cart-qty">' +
            '<button class="cart-qty-btn" data-key="' + x(item.key) + '" data-action="dec" data-qty="' + item.quantity + '">&#8722;</button>' +
            '<span class="cart-qty-val">' + item.quantity + '</span>' +
            '<button class="cart-qty-btn" data-key="' + x(item.key) + '" data-action="inc" data-qty="' + item.quantity + '">+</button>' +
          '</div>' +
          '<button class="cart-remove" data-key="' + x(item.key) + '">Remove</button>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  function itemsClickHandler(e) {
    var qBtn = e.target.closest('.cart-qty-btn');
    var rBtn = e.target.closest('.cart-remove');
    if (qBtn && !qBtn.disabled) {
      qBtn.disabled = true;
      var newQty = qBtn.dataset.action === 'inc'
        ? parseInt(qBtn.dataset.qty, 10) + 1
        : Math.max(0, parseInt(qBtn.dataset.qty, 10) - 1);
      changeQty(qBtn.dataset.key, newQty);
    }
    if (rBtn && !rBtn.disabled) {
      rBtn.disabled = true;
      rBtn.textContent = '\u2026';
      changeQty(rBtn.dataset.key, 0);
    }
  }

  async function changeQty(key, qty) {
    if (isBusy) return;
    isBusy = true;
    try {
      var cart = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function(r) { return r.json(); });
      syncCount(cart.item_count);
    } catch (e) {}
    isBusy = false;
    fetchCart();
  }

  function syncCount(n) {
    document.querySelectorAll('.cart-count, .cv-cart-count').forEach(function(el) { el.textContent = n; });
  }
  function money(cents) { return '\u20b9' + Math.round(cents / 100).toLocaleString('en-IN'); }
  function x(s) { return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }

  window.__8thSinOpenCart = openCart;
  window.__8thSinRefreshCart = fetchCart;
})();
